import "./ListingsComingSoon.scss";

const ICON_BASE = "https://timber.mhmcdn.com/site/marketing/icons/listings";

const SURVEY_URL =
  "https://www.musthavemenus.com/home/designs/?intercom_survey_id=64583930";

const PARTNER_ICONS: { src: string; alt: string; noRound?: boolean }[] = [
  { src: `${ICON_BASE}/fb.svg`, alt: "Facebook" },
  { src: `${ICON_BASE}/yelp.svg`, alt: "Yelp" },
  { src: `${ICON_BASE}/google.png`, alt: "Google" },
  { src: `${ICON_BASE}/instagram-2016-5.svg`, alt: "Instagram", noRound: true },
  { src: `${ICON_BASE}/uber-eats.png`, alt: "Uber Eats" },
  { src: `${ICON_BASE}/apple-maps.png`, alt: "Apple Maps" },
  { src: `${ICON_BASE}/tripadvisor.png`, alt: "Tripadvisor" },
  { src: `${ICON_BASE}/doordash.png`, alt: "DoorDash" },
  { src: `${ICON_BASE}/opentable.png`, alt: "OpenTable" },
];

export default function ListingsComingSoon() {
  return (
    <div className="listings-coming-soon page">
      <div className="lcs-inner">
        <section className="lcs-intro">
          <h2 className="lcs-eyebrow">Print, Signage, Website, QR, and now...</h2>
        </section>

        <section className="lcs-feature">
          <div className="lcs-title">
            <img className="lcs-title-icon" src={`${ICON_BASE}/listings.svg`} alt="" />
            <span>Listings</span>
          </div>

          <div className="lcs-icons">
            {PARTNER_ICONS.map((icon) => (
              <img
                key={icon.alt}
                className={icon.noRound ? "no-round" : ""}
                loading="lazy"
                src={icon.src}
                alt={icon.alt}
              />
            ))}
          </div>

          <p className="lcs-coming">Coming Q3 '26</p>

          <a className="lcs-survey" href={SURVEY_URL} target="_blank" rel="noreferrer">
            Interested? Take our 2 min survey
            <img
              className="lcs-survey-arrow"
              src="https://timber.mhmcdn.com/site/marketing/icons/ThickArrowRed.svg"
              alt=""
            />
          </a>

          <p className="lcs-pro">
            Available with{" "}
            <img
              className="lcs-pro-star"
              src="https://timber.mhmcdn.com/site/marketing/icons/ProPricingStar.svg"
              alt="pro star"
            />{" "}
            Pro Plan
          </p>
        </section>
      </div>
    </div>
  );
}
